import { LifestyleAndHealthConditions } from "@/components/report/LifestyleAndHealthConditions";
import {
  LifestyleAndHealthConditionsResponse,
  ReportPageBaseProps,
} from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { usePageUserType } from "@/utils/router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
export function LifestyleAndHealthConditionsPage({
  setIndicator,
}: ReportPageBaseProps) {
  const { uuid } = useParams();
  const axios = useAxios();
  const userType = usePageUserType();
  const [data, setData] = useState<LifestyleAndHealthConditionsResponse | null>(
    null
  );
  useEffect(() => {
    (async () => {
      if (uuid != null) {
        const response = await axios.get(
          `/api/report/${uuid}/lifestyle_and_health_conditions`
        );
        setData(response.data);
        setIndicator(false);
      }
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null || data == null) return null;

  return (
    <LifestyleAndHealthConditions
      data={data}
      uuid={uuid}
      reportType={userType}
    />
  );
}
